<template>
  <v-content class="content_body" id="passo-5">
    <v-flex xs12>
      <v-layout col>
        <v-flex xs6>
          <PremioComissaoForm :delegate="this" />
        </v-flex>
        <v-flex xs1 border-right></v-flex>
        <v-flex xs6>
          <FormaPagamentoForm
            @select-installment="onSelectInstallment"
            @select-dias-primeira-parcela="onSelectDiasPrimeiraParcela"
            :delegate="this"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-content>
</template>

<script lang="js">
import _ from "lodash";
import { toMoneyString } from "@/libs/utils";
import CalcMixin, { ATX, ACC } from "@/mixins/CalcMixin";
import PremioComissaoForm from "./PremioComissaoForm.vue";
import FormaPagamentoForm from "./FormaPagamentoForm.vue";

export default {
  name: "PremioEComissao",
  step: {
    id: 3,
    number: "02",
    text: "Prêmio e Comissão",
    class: "proposta__container-passo-5",
    step: "CommissionForm",
    previousStep: "EndorsementForm",
    nextStep: "CommissionForm"
  },
  props: { policy: Object },
  components: { PremioComissaoForm, FormaPagamentoForm },
  mixins: [CalcMixin],
  data() {
    return {
      isInputCommissionActive: false,
      development: true,
      moneyConfig: {},
      paymentDays: ["7"],
      showTooltipTax: false,
      showTooltipCommission: false,
      lock_icon: "lock_open",
      lock_icon_values: {
        open: "lock_open",
        close: "lock",
      },
      agravamento: false,
      slider: {
        dragger: 0,
        min: 0,
        max: 0,
        limit: 0,
        limitType: "$",
        color: "#282498",
        track_color: "gray",
        step: 1,
        original: 20,
        update: false,
      },
      //TODO: Remover todas as va
      calculator: {
        commission: 0,
        commissionPercentual: 0,
        appliedTax: 0,
        premium: 0,
        originalCommission: 0,
        originalCommissionTax: 0,
        originalCommissionPercentual: 0,
        originalAppliedTax: 0,
        originalPremium: 0,
        aggravation: 0,
        fixedAggravationCompare: 41,
        /* Payment values */
        parcelNumber: 0,
        additional_fractionation: 0,
        first_parcel: 0,
        paymentDay: 7,
      },
      parcels: [],
      disponibleParcels: [],
      fractionation: 0, // Fracionamento
      PARCEL_MIN_VAL: 1500,
      PREMIUM_PARCELLATION_CUT: 20000,
      relevant_serasa: false,
      isCommissionSeted: false,
      isInputTaxa: false,
      commissionMaximumLimit: 0,
      mensagemMaximoMinimo: false,
      recusada_por_limite: false,
      /* Payment values */
      parcelNumber: 0,
      additional_fractionation: 0,
      first_parcel: 0,
      paymentDay: 7,

      /* Variveis de cálculos */
      Crminlabel: 0,
      CrmaxLabel: "",
      permissao_alterar_portal: true,
      casas_decimais: 4
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.defineOriginalValues();
    this.defineCommissionSliderValues();
    this.definePaymentDays();
    this.defineParcels();
    this.calculateParcelValues();
    this.moneyConfig = this.$settings.moneyConfig;
    this.$forceUpdate();
  },
  computed: {
    proposta: {
      get: function() { return this.policy; }
    },

    premio() {
      return toMoneyString(this.P);
    },

    commissionFormatted: {
      get: function () {
        let commission = this.Cr.toString();
        if (this.isInputCommissionActive) {
          return commission;
        } else {
          let c = commission.replace(",", ".");
          return toMoneyString(parseFloat(c));
        }
      },
      set: function (newValue) {
        let commission = newValue
            .toString()
            .replace(",", ".")
            .replace(/[^0-9\.]/g, "")
            .replace("R$", "");

        this.Cr = Number(commission);
      },
    },

    lengthSliderLimit() {
      return "width: 9.18564%";
    },

    taxaFormatada: {
      get: function () {
        let taxa = this.Tx;
        if (this.isInputTaxa) {
          taxa = this.Tx.toString().replace(",", ".");
        }
        return this.formatValue(taxa);
      },
      set: function (newValue) {
        this.Tx = newValue;
      },
    },

    percentualComissaoFormatada: {
      get: function () {
        return this.formatValue(this.Cc);
      },
      set: function (newValue) {
        this.Cc = newValue;
      },
    },
  },
  methods: {
    definePaymentDays() {
      let initial = 7;
      let limit = 20;
      this.paymentDays = _.range(initial, limit).map(
        day => ({ text: day.toString(), value: day })
      );
    },

    defineOriginalValues() {
      if (this.proposta) {
        try {
          this.Cc = this.Cco;
          this.cct = this.Cco;
          this.Cr = this.Cro;
          this.Tx = this.Txo;
          this.P = this.Po;

          this.agravamento = this.proposta.agravamento_passo5;
          if (this.agravamento == false)
            this.lock_icon = this.lock_icon_values.close;

          this.permissao_alterar_portal = this.proposta.permissao_alterar_portal;
          this.relevant_serasa = this.proposta.tomador_serasa_relevante;

          this.recusada_por_limite = this.proposta.recusada_por_limite;
        } catch (error) {}
      }
    },

    defineCommissionSliderValues() {
      this.slider.limitType = "$";
      this.slider.min = 0;
      this.slider.max = 100;
      this.slider.limit = this.calculateLimit();
      this.slider.update = true;
      this.slider.dragger = 20;
      this.Crmax = this.calcularComissaoMaxima();
      this.Crmin = this.calcularComissaoMinima();
      this.Txmin = this.calcularTaxaMinima();
      this.CrmaxLabel = this.calcularComissaoMaximaLabel(
        this.lock_icon == this.lock_icon_values.close
      );
      this.Crminlabel = this.calcularComissaoMinimaLabel();
    },

    defineParcels() {
      if (this.proposta.produto_parcelamentos == null) {
        return;
      }
      const { produto_parcelamentos } = this.proposta;
      const makeParcel = (item, index) => ({
        index: index,
        parcelId: item.id_produto_parcela,
        description: item.descricao,
        parcelNumbers: item.numero_parcelas,
        interests: item.juros,
      });
      this.parcels = produto_parcelamentos.map(
        makeParcel
      ).sort(
        (a, b) => a.parcelNumbers - b.parcelNumbers
      );
    },

    defineCommissionMaxValue() {
            this.commissionMaximumLimit = 0;

      let maximumValue =
          (this.calculator.originalPremium * 41) /
          this.calculator.originalAppliedTax;

      this.commissionMaximumLimit = (maximumValue * this.fixeMaxTax) / 100;
    },

    emitProposalValues() {
            if (this.calculator.parcelNumber == null) return null;

      let selectedParcel = this.parcels.find(
        (p) => p.index == this.calculator.parcelNumber
      );

      if (selectedParcel) {
        let proposalParcels = [
          {
            id_parcelamento: selectedParcel.parcelId,
            premio_total: Number(this.P),
            nr_parcela: selectedParcel.parcelNumbers,
            qt_total: Number(selectedParcel.value),
            vl_adicional:
            this.calculator.additional_fractionation /
              Number(selectedParcel.parcelNumbers),
          },
        ];

        let proposalCoverages = [];
        if (this.proposta.coberturas.length == 1) {
          let coverage = this.proposta.coberturas[0];
          proposalCoverages = [
            {
              id: Number(coverage.id),
              premio: Number(this.P),
            },
          ];
        } else {
          let sum = this.proposta.coberturas.reduce(
            (a, b) => a + (b["premio"] || 0),
            0
          );

          this.proposta.coberturas.forEach((coverage) => {
            let percent = (coverage.premio * 100) / sum;
            let premium = (this.P * percent) / 100;

            proposalCoverages.push({
              id: Number(coverage.id),
              premio: Number(premium),
            });
          });
        }

        const postData = {
          id_proposta: Number(this.idProposta),
          id_produto: Number(this.idProduto),
          taxa_risco: this.Tx,
          comissao_corretor: this.Cc,
          quantidade_parcelas: Number(selectedParcel.parcelNumbers),
          dias_primeira_parcela: Number(this.calculator.paymentDay),
          comissao_reais: this.Cr,
          agravamento: this.agravamento,
          coberturas: proposalCoverages,
          parcelamento: proposalParcels,
        };

        this.$emit("emitProposalValues", postData);
      }
    },

    formatValue(value) {
      return parseFloat(Number(value).toFixed(this.casas_decimais)) || 0;
    },

    calculateParcelValues() {
      this.disponibleParcels = [];

      if (this.relevant_serasa) {
        let parcel = this.parcels[0];
        this.setParcelValues(0);
        parcel.index = 0;
        parcel.additional_fractionation = 0;
        parcel.value = this.P;
        this.calculator.first_parcel = parcel.value;
        this.disponibleParcels.push(parcel);
        return;
      }

      for (let i = 0; i < this.parcels.length; i++) {
        try {
          let parcel = this.parcels[i];
          let parcelNumbers = parcel.parcelNumbers;
          let interests = parseFloat(parcel.interests) / 100;
          let additional_fractionation = 0;


          let parcelValue =
              parseFloat(this.P + additional_fractionation) / parcelNumbers;

          let additional_fractionation_parcel =
              parseFloat(additional_fractionation) / parcelNumbers;

          let totalPremiun =
              parseFloat(this.P) + parseFloat(additional_fractionation);

          if (parcelNumbers >= 2) {
            if (parcelValue < this.PARCEL_MIN_VAL) continue;
          }

          if (parcelNumbers >= 4) {
            if (
              parseFloat(this.P) < parseFloat(this.PREMIUM_PARCELLATION_CUT) &&
                interests == 0
            )
              continue;
          }

          parcel.index = i;
          parcel.additional_fractionation = additional_fractionation;
          parcel.value = parcelValue;

          this.disponibleParcels.push(parcel);
        } catch (error) {
          console.error("Erro ao calcular as parcelas. Erro: " + error);
        }
      }

      this.calculator.parcelNumber = 0;
      this.setParcelValues(0);
    },

    setParcelValues(parcelNumber) {
                  let selectedParcel = this.parcels.find((p) => p.index == parcelNumber);
      if (selectedParcel) {
        this.calculator.additional_fractionation =
          selectedParcel.additional_fractionation != null
          ? selectedParcel.additional_fractionation
          : 0;
        this.calculator.first_parcel =
          selectedParcel.value != null ? selectedParcel.value : 0;
      }
    },

    onSelectParcel() {
      this.setParcelValues(this.calculator.parcelNumber);
    },

    onSpecialRequest() {
      this.$emit("showQuestionamento");
    },

    onDesist() {
      this.$emit("desistir");
    },

    onEmitirApolice() {
      this.emitProposalValues();
      this.$emit("abrirModalTermosAceite");
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    calculateLimit() {
      return this.slider.limitType == "$" ?
        this.calculator.originalCommission :
        this.calculator.originalAppliedTax;
    },



    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    atualiza_valores_comissao(comissao) {
            //   """ Metodo que atualiza os valores """

      //# Premio so depende da taxa
      let premio = 0;
      let taxa = 0;
      let comissao_corretor = 0;
      let comissao_reais = 0;

      premio = this.calcula_premio_comissao(comissao);
      taxa = this.calcula_taxa_comissao(comissao);

      //# Calculando os valores para a regiao acima do original
      if (comissao >= this.Cro) {
        //calcula os valores do comissao do corretor e comissao em reais acima do original
        comissao_corretor = this.calcula_comissao_corretor(taxa);
        //# A comissao em reais depende do premio e da comissao do corretor
        comissao_reais = (premio * comissao_corretor) / 100;
      } else {
        //calcula os valores do comissao do corretor e comissao em reais abaixo do original
        // # Como nao tem agravamento para valores abaixo do original e foi utilizado Po = ((Po - Cro) / Po) * Txo
        //# para passar pelo minimo entao Cr = (Tx / Txo) * Po - (Po - Cro)
        comissao_reais = comissao;
        taxa = ((comissao + (this.Po - this.Cro)) / this.Po) * this.Txo;
        premio = this.calcularPremio(taxa);
        comissao_corretor = (100 * comissao_reais) / premio;
        if (comissao_corretor < this.Ccmin) {
          this.Txmin = this.calcularTaxaMinima();
          premio = this.calcularPremio(this.Txmin);
          comissao_corretor = this.Ccmin;
          comissao_reais = (premio * comissao_corretor) / 100;
        }
      }

      this.atualiza_valores_na_tela(
        taxa,
        premio,
        comissao_reais,
        comissao_corretor
      );
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    calcula_comissao_corretor(taxa) {
            //""" Metodo que calcula a comissao do corretor com agravamento """

      //# Se o cadeado estiver aberto entao agravar a comissao do corretor
      let agravamento = 0;
      if (this.lock_icon == "lock_open") agravamento = taxa - this.Txo;

      let cc = this.Cco + (this.acc * agravamento) / this.atx;

      //# Verificando se a comissao agravada superou o maximo permitido
      if (cc > this.Ccmax) cc = this.Ccmax;

      if (this.lock_icon == "lock_open") this.cct = cc;

      return this.cct;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    calcula_premio_comissao(comissao) {
            //""" Metodo que calcula o premio """

      //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);

      return (taxa / this.Txo) * this.Po;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    calcula_taxa_comissao(comissao) {
            //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);
      return taxa;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    slider_to_taxa(slider_valor) {

      // Valor do slider
      let s = parseFloat(slider_valor);
      let taxa = 0;

      //Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //Convertendo o valor do slider para a taxa quando este <= So
      if (s <= this.So)
        taxa =
        this.Txmin +
        (s - this.slider.min) *
        ((this.Txo - this.Txmin) / (this.So - this.slider.min));
      else
        taxa =
        this.Txo +
        (s - this.So) *
        ((this.Txmax - this.Txo) / (this.slider.max - this.So));

      return taxa;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    taxa_to_slider(taxa) {
            let s = 0;
      if (taxa <= this.Txo) {
        s =
          ((taxa - this.Txmin) * (this.So - this.slider.min)) /
          (this.Txo - this.Txmin) +
          this.slider.min;
      } else {
        s =
          ((taxa - this.Txo) * (this.slider.max - this.So)) /
          (this.Txmax - this.Txo) +
          this.So;
      }

      return s;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    slider_to_comissao(slider_valor) {
            //""" Metodo que calcula o valor da comissao a partir do slider """

      //# Valor do slider
      let s = parseFloat(slider_valor);
      let comissao = 0;
      //# Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //# Convertendo o valor do slider para a comissao quando este <= So
      if (s <= this.So) {
        comissao =
          this.Crmin +
          (s - this.slider.min) *
          ((this.Cro - this.Crmin) / (this.So - this.slider.min));
      } else {
        comissao =
          this.Cro +
          (s - this.So) *
          ((this.Crmax - this.Cro) / (this.slider.max - this.So));
      }
      return comissao;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    comissao_to_slider(comissao) {
            let s = 0;
      if (comissao <= this.Cro) {
        s =
          ((comissao - this.Crmin) * (this.So - this.slider.min)) /
          (this.Cro - this.Crmin) +
          this.slider.min;
      } else {
        s =
          ((comissao - this.Cro) * (this.slider.max - this.So)) /
          (this.Crmax - this.Cro) +
          this.So;
      }
      return s;
    },

    /**
     * TODO(dias): need more information about this function
     * to refactor properly.
     */
    atualiza_valores_na_tela(taxa, premio, comissao_reais, comissao_corretor) {
            this.P = premio;
      this.Tx = taxa;
      this.Cr = comissao_reais;
      this.Cc = comissao_corretor;
      this.commissionFormatted = this.Cr;
    },

    onSelectInstallment(installment) {
      this.$emit("select-installment", installment);
    },
    onSelectDiasPrimeiraParcela(installment) {
      this.$emit("select-dias-primeira-parcela", installment);
    }

  }
};
</script>

<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px !important;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/PremioEComissao.vue